export default __webpack_public_path__ + "static/9-rating-delivery-f69fc1fb085fb5fb793c1fe43e360b70.png";